import * as Library from '../library/index';
import { Base } from './base';
import { Guid } from './guid';

export class Image extends Base {
  public href: string;
  public size: string;
  public style: object;

  public hasHRef() {
    return Library.isStringWithLength(this.href);
  }

  public hasSize() {
    return Library.isStringWithLength(this.size);
  }

  constructor();
  constructor(options: object)
  constructor(options?: any) {
    super(options);
    this.uid = Guid.CHAR();
    this.href = Library.init(options, 'href', '');
    this.size = Library.init(options, 'size', '');
    this.style = Library.init(options, 'style', {});

  }
}
